import React from "react";
import ReactDOM from "react-dom/client";
import ProjectRoot from "./root/ProjectRoot";

// createRoot(document.getElementById("root"))
//     .render(
//         // <SiteRoot/>
//         <ProjectRoot/>
//     );
const rootElement = document.getElementById("root");
ReactDOM.createRoot(rootElement).render(
    <ProjectRoot/>
)
